import React, { useState } from 'react'
import { intl } from 'lang/intl'
import classnames from 'classnames'
import { FormattedDate } from 'react-intl'

import Chyron, { ChyronSize } from './chyron'

import './webinar-info-chyron.scss'

interface WebinarInfoChyronProps {
  title: string
  date: Date
  thumbnail: string
}

const WebinarInfoChyron = ({
  title,
  date,
  thumbnail,
}: WebinarInfoChyronProps) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  return (
    <Chyron
      size={ChyronSize.Medium}
      kickerPosition="top"
      kicker={intl.formatMessage({ defaultMessage: 'Webinar Info' })}
    >
      <div className="webinar-info-chyron">
        {thumbnail && (
          <img
            className={classnames('thumbnail', {
              'thumbnail-loaded': imageLoaded,
            })}
            src={thumbnail}
            alt={intl.formatMessage({
              defaultMessage: 'Thumbnail of the webinar',
            })}
            onLoad={() => setImageLoaded(true)}
          />
        )}
        <div className="info">
          <p className="title">{title}</p>
          <p className="date">
            <FormattedDate value={date} dateStyle="full" timeStyle="short" />
          </p>
        </div>
      </div>
    </Chyron>
  )
}

export default WebinarInfoChyron
